<template>
  <!-- WEB -->
  <nav
    class="relative flex justify-between items-center container"
    aria-label=""
    style="background: #f0f8ff00"
  >
    <a
      class="text-3xl font-bold leading-none hidden lg:flex"
      href="javascript:;"
      :class="{
        'mt-5': !showAuthenticatedData
      }"
    >
      <img
        v-if="urlOriginIsBrandIn"
        :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
        class="cursor-pointer w-24 md:w-48"
        alt="producto"
        @click="$router.push('/')"
      />
      <img
        v-else
        :src="require(`@/assets/images/COT-img/logo.png`)"
        class="cursor-pointer w-24 md:w-48"
        alt="producto"
        @click="$router.push('/')"
      />
    </a>
    <template v-if="showAuthenticatedData">
      <div class="lg:hidden inline-flex w-full">
        <div class="flex items-center mb-8">
          <button class="navbar-burger flex items-center text-black p-3">
            <svg
              class="block h-4 w-4 fill-current"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
            </svg>
          </button>
        </div>
        <div class="lg:hidden w-full">
          <div class="flex items-center mb-8 m-auto w-full">
            <router-link
              :to="{ name: 'home' }"
              tag="a"
              class="text-3xl font-bold leading-none m-auto"
            >
              <img
                v-if="urlOriginIsBrandIn"
                :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
                style="margin-top: 2rem"
                alt="producto"
                class="w-28"
              />
              <img
                v-else
                :src="require(`@/assets/images/COT-img/logo.png`)"
                style="margin-top: 2rem"
                alt="producto"
                class="w-28"
              />
            </router-link>
          </div>
        </div>
      </div>
      <ul
        v-if="!showInputSearch"
        class="hidden absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 lg:flex lg:mx-auto lg:items-center lg:w-auto lg:space-x-10"
      >
        <li>
          <router-link
            :to="{ name: 'home' }"
            tag="a"
            class="text-lg font-bold h-4 font-weight-bold font-crimson_pro leading-5 tracking-normal text-left"
            :class="{ activeSection: activeSection === 1 }"
          >
            Inicio
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'catalogue' }"
            tag="a"
            class="text-lg text-theme-23 font-bold hover:text-theme-9 font-crimson_pro"
            :class="{ activeSection: activeSection === 2 }"
          >
            Catálogo
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'quotations' }"
            tag="a"
            class="text-lg text-theme-23 font-bold hover:text-theme-9 font-crimson_pro"
            :class="{ activeSection: activeSection === 3 }"
          >
            Mis cotizaciones
          </router-link>
        </li>
        <li>
          <button
            class="flex items-center border border-black rounded-[10px] p-2"
            @click="handleClickSearch"
          >
            <SearchIcon />
          </button>
        </li>
      </ul>
      <div
        v-else
        class="hidden absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 lg:flex lg:mx-auto lg:items-center w-[300px] lg:space-x-10 z-50"
      >
        <div class="flex flex-col relative w-full">
          <div
            class="flex items-center border border-black bg-white rounded-lg p-2"
          >
            <SearchIcon />
            <input
              ref="searchInputMobile"
              v-model="inputSearch"
              type="text"
              placeholder="Buscar producto..."
              class="w-full px-2 py-1 border-none outline-none bg-transparent placeholder-black"
            />
            <button @click="handleClickSearch" class="cursor-pointer">
              <XIcon />
            </button>
          </div>
          <div
            v-if="inputSearch.length > 0"
            class="absolute right-0 top-12 bg-white flex flex-col w-full p-2 z-40 rounded-b-[10px] overflow-y-auto max-h-[300px]"
            :class="{ 'h-[50px]': products?.length < 2 }"
          >
            <template v-if="loadingProducts">
              <div class="flex items-center justify-center">
                <LoaderIcon />
              </div>
            </template>
            <template v-else-if="products?.length === 0">
              <div class="flex items-center justify-center">
                <p>No se encontraron productos</p>
              </div>
            </template>
            <template v-else>
              <div
                v-for="product in products"
                :key="product.id"
                class="flex flex-row w-full mb-2 cursor-pointer hover:bg-gray-100 space-x-2"
                @click="goToProduct(product)"
              >
                <div class="w-10 h-10 flex-none">
                  <img
                    v-if="product.image.length > 0"
                    :src="product.image[0]"
                    alt="producto"
                    class="w-full h-full object-cover"
                  />
                  <img
                    v-else
                    src="@/assets/images/product.svg"
                    alt="producto"
                    class="w-full h-full object-cover"
                  />
                </div>
                <div class="flex flex-col min-w-0">
                  <p class="text-sm line-clamp-2 w-full" :title="product.name">
                    {{ product.name }}
                  </p>
                  <p class="text-xs text-gray-600">sku: {{ product.sku }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="hidden sm:flex py-2">
        <Dropdown
          :user="user"
          :image-profile="getImageProfile()"
          @logout="logout"
        />
      </div>
      <Cart
        v-if="!isCpaCompany"
        class="!px-2 !py-2 !bg-transparent flex md:hidden"
      />
      <div class="sm:hidden flex py-2">
        <div class="intro-x dropdown m-4">
          <div
            class="dropdown-toggle notification cursor-pointer"
            :class="{
              'notification--bullet':
                lengthMessages !== this.$store.state?.main?.bellMessages.length
            }"
            role="button"
            aria-expanded="false"
            @click="
              lengthMessages = this.$store.state?.main?.bellMessages.length
            "
          >
            <BellIcon class="m-auto bell" />
          </div>
          <div
            class="notification-content pt-2 dropdown-menu max-h-96 overflow-auto"
          >
            <div class="notification-content__box dropdown-menu__content box">
              <div
                v-for="(bellMessage, key) in this.$store.state?.main
                  ?.bellMessages || []"
                :key="key"
                class="cursor-pointer relative flex items-center"
                :class="{ 'mt-5': key }"
                style="
                  background: #f1f1f1;
                  padding: 6px;
                  border-radius: 10px;
                  margin: 12px 0;
                  border-left: 3px solid #ce0100;
                "
              >
                <div class="ml-2 overflow-hidden">
                  <div class="flex items-center">
                    <a
                      href="javascript:;"
                      class="font-normal mr-5 font-poppins"
                    >
                      {{ getMainMessage(bellMessage) }}
                    </a>
                  </div>
                  <div
                    class="text-xs text-gray-500 ml-auto whitespace-nowrap font-poppins"
                    v-if="false"
                  ></div>
                </div>
                <div class="ml-2 w-12 h-12 flex-none image-fit mr-1">
                  <img
                    alt="Imagen de notificación"
                    class="rounded-full object-contain"
                    :src="getMainImage(bellMessage)"
                    crossorigin="anonymous"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        v-if="!showInputSearch"
        class="sm:hidden flex items-center border border-black rounded-[10px] p-2"
        @click="handleClickSearch"
      >
        <SearchIcon />
      </button>
      <div
        v-else
        class="sm:hidden absolute top-4 flex items-center w-screen z-50"
      >
        <div class="flex flex-col w-full relative">
          <div
            class="flex items-center border border-black bg-white rounded-lg p-2"
          >
            <SearchIcon />
            <input
              ref="searchInputDesktop"
              v-model="inputSearch"
              type="text"
              placeholder="Buscar producto..."
              class="w-full px-2 py-1 border-none outline-none bg-transparent placeholder-black"
            />
            <button @click="handleClickSearch" class="cursor-pointer">
              <XIcon />
            </button>
          </div>
          <div
            v-if="inputSearch.length > 0"
            class="absolute right-0 top-12 bg-white flex flex-col w-full p-2 z-40 rounded-b-[10px] overflow-y-auto max-h-[300px]"
            :class="{ 'h-[50px]': products?.length < 2 }"
          >
            <template v-if="loadingProducts">
              <div class="flex items-center justify-center">
                <LoaderIcon />
              </div>
            </template>
            <template v-else-if="products?.length === 0">
              <div class="flex items-center justify-center">
                <p>No se encontraron productos</p>
              </div>
            </template>
            <template v-else>
              <div
                v-for="product in products"
                :key="product.id"
                class="flex flex-row w-full mb-2 cursor-pointer hover:bg-gray-100 space-x-2"
                @click="goToProduct(product)"
              >
                <div class="w-10 h-10 flex-none">
                  <img
                    v-if="product.image.length > 0"
                    :src="product.image[0]"
                    alt="producto"
                  />
                  <img
                    v-else
                    src="@/assets/images/product.svg"
                    alt="producto"
                  />
                </div>
                <div class="flex flex-col min-w-0">
                  <p class="text-sm line-clamp-2" :title="product.name">
                    {{ product.name }}
                  </p>
                  <p class="text-xs text-gray-600">sku: {{ product.sku }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </nav>
  <!-- MOVIL -->
  <div class="navbar-menu relative z-50 hidden" v-if="showAuthenticatedData">
    <nav
      class="fixed top-0 left-0 bottom-0 flex flex-col w-5/6 max-w-sm py-6 px-6 bg-white border-r overflow-y-auto"
      aria-label="menu"
    >
      <button
        class="navbar-close text-right absolute right-0 pr-4"
        ref="navBarClose"
      >
        <svg
          class="h-6 w-6 text-gray-400 cursor-pointer hover:text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
      <div class="flex items-center mb-8">
        <router-link
          :to="{ name: 'home' }"
          tag="a"
          class="text-3xl font-bold leading-none"
          @click="$refs.navBarClose.click()"
        >
          <img
            v-if="urlOriginIsBrandIn"
            :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
            alt="producto"
            style="margin-top: 2rem"
            class="w-48"
          />
          <img
            v-else
            :src="require(`@/assets/images/COT-img/logo.png`)"
            alt="producto"
            style="margin-top: 2rem"
            class="w-48"
          />
        </router-link>
      </div>
      <div class="accordion" id="accordionExample">
        <div
          class="accordion-item bg-white border-t-0 border-l-0 border-r-0 border-b border-gray-200"
        >
          <h2 class="accordion-header mb-0" id="headingOne">
            <button
              class="accordion-button relative flex items-center w-full py-4 px-2 text-base text-gray-800 text-left bg-white border-0 rounded-none transition focus:outline-none"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <img
                :src="getImageProfile()"
                class="w-8 bg-theme-11 rounded-full mr-4"
                alt="avatar"
                crossorigin="anonymous"
              />
              <h1 class="text-black font-poppins">{{ user.name }}</h1>
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body py-4 px-2">
              <div>
                <ul>
                  <li class="mb-1 font-poppins">
                    <router-link
                      :to="{ name: 'my-profile' }"
                      tag="a"
                      class="block p-4 text-sm font-semibold text-theme-1 rounded font-poppins"
                      :class="{
                        'bg-blue-50': activeSectionMobile === 1,
                        'hover:text-theme-16': activeSectionMobile === 1
                      }"
                      @click="$refs.navBarClose.click()"
                    >
                      Mi perfil
                    </router-link>
                  </li>
                  <li class="mb-1 font-poppins">
                    <router-link
                      :to="{ name: 'favorites' }"
                      tag="a"
                      class="block p-4 text-sm font-semibold text-theme-1 rounded font-poppins"
                      :class="{
                        'bg-blue-50': activeSectionMobile === 2,
                        'hover:text-theme-16': activeSectionMobile === 2
                      }"
                      @click="$refs.navBarClose.click()"
                    >
                      Mis favoritos
                    </router-link>
                  </li>
                  <li class="mb-1 font-poppins">
                    <a
                      class="block p-4 text-sm font-semibold text-theme-1 hover:bg-blue-50 hover:text-theme-16 rounded font-poppins"
                      href="javascript:;"
                      @click="logout"
                    >
                      Cerrar sesión
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <ul>
          <li class="mb-1 px-1 mt-4">
            <router-link
              :to="{ name: 'home' }"
              tag="a"
              class="block p-4 text-sm font-semibold text-theme-1 rounded font-poppins"
              :class="{
                'bg-blue-50': activeSectionMobile === 3,
                'hover:text-theme-16': activeSectionMobile === 3
              }"
              @click="$refs.navBarClose.click()"
            >
              Inicio
            </router-link>
          </li>
          <li class="mb-1 px-1">
            <router-link
              :to="{ name: 'catalogue' }"
              tag="a"
              class="block p-4 text-sm font-semibold text-theme-1 rounded font-poppins"
              :class="{
                'bg-blue-50': activeSectionMobile === 4,
                'hover:text-theme-16': activeSectionMobile === 4
              }"
              @click="$refs.navBarClose.click()"
            >
              Catálogo
            </router-link>
          </li>
          <li class="mb-1 px-2">
            <router-link
              :to="{ name: 'quotations' }"
              tag="a"
              class="block p-4 text-sm font-semibold text-theme-1 rounded font-poppins"
              :class="{
                'bg-blue-50': activeSectionMobile === 5,
                'hover:text-theme-16': activeSectionMobile === 5
              }"
              @click="$refs.navBarClose.click()"
            >
              Mis cotizaciones
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import Dropdown from '@/components/dropdown/Main.vue'
import Cart from '@/components/cart/Main.vue'
import { cleanSession } from '@/utils/tools'

export default {
  components: {
    Dropdown,
    Cart
  },
  data() {
    return {
      showAuthenticatedData: undefined,
      user: undefined,
      routerName: this.$route.name,
      lengthMessages: 0,
      showInputSearch: false,
      inputSearch: '',
      products: [],
      loadingProducts: false,
      timeoutSearch: null
    }
  },
  beforeMount() {
    this.showAuthenticatedData = !!this.$store.state?.auth?.user
    if (this.showAuthenticatedData) {
      this.user = this.$store.state.auth.user
    }
  },
  mounted() {
    // open
    const burger = document.querySelectorAll('.navbar-burger')
    const menu = document.querySelectorAll('.navbar-menu')
    const close = document.querySelectorAll('.navbar-close')

    const toggleFunction = () => {
      for (let j = 0; j < menu.length; j++) {
        menu[j].classList.toggle('hidden')
      }
    }

    if (burger.length && menu.length) {
      for (let i = 0; i < burger.length; i++) {
        burger[i].addEventListener('click', toggleFunction)
      }
    }
    // close
    if (close.length) {
      for (let i = 0; i < close.length; i++) {
        close[i].addEventListener('click', toggleFunction)
      }
    }
  },
  beforeUnmount() {
    const burgers = document.querySelectorAll('.navbar-burger')
    Array.prototype.forEach.call(burgers, function (el) {
      el.removeEventListener('click', () => true)
    })

    const closes = document.querySelectorAll('.navbar-close')
    Array.prototype.forEach.call(closes, function (el) {
      el.removeEventListener('click', () => true)
    })
  },
  methods: {
    getImageProfile() {
      const avatarArray = this.$store.state?.auth?.user?.avatar
      return Array.isArray(avatarArray) && avatarArray.length
        ? avatarArray[0]
        : require('@/assets/images/user.svg')
    },
    async logout() {
      cash('body').trigger('click')
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          '/auth/sign-out-by-token',
          {},
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        cleanSession(this.$store, this.$router)
      }
    },
    getMainMessage(bellMessage) {
      switch (bellMessage.type) {
        case 'QUOTATION':
          return `Te han enviado un mensaje por la cotización ${bellMessage.data?.quotation_id}`
        case 'STATUS_QUOTATION':
          return `El estatus de la cotización ${bellMessage.data?.id} ha cambiado`
        case 'PRICE_QUOTATION':
          return `El precio de la cotización ${bellMessage.data?.id} ha cambiado`
      }
    },
    getMainImage(bellMessage) {
      const imageArray =
        bellMessage?.type === 'QUOTATION'
          ? bellMessage?.data?.quotation?.product?.image
          : bellMessage?.data?.product?.image
      return Array.isArray(imageArray) && imageArray.length
        ? imageArray[0]
        : require('@/assets/images/product.svg')
    },
    async handleClickSearch() {
      this.showInputSearch = !this.showInputSearch
      this.inputSearch = ''
      if (this.showInputSearch) {
        await this.$nextTick()
        if (this.$refs.searchInputMobile) {
          this.$refs.searchInputMobile.focus()
        }
        if (this.$refs.searchInputDesktop) {
          this.$refs.searchInputDesktop.focus()
        }
      }
    },
    async handleSearch() {
      this.loadingProducts = true
      try {
        const response = await this.axios.get(
          '/sales-operator/products/products-by-search-specific',
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            },
            params: {
              search: this.inputSearch,
              per_page: 49,
              without_especial: true
            }
          }
        )
        this.products = response.data.products.data
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingProducts = false
      }
    },
    goToProduct(product) {
      this.products = []
      this.inputSearch = ''
      this.showInputSearch = false
      this.$router.push({ name: 'products', params: { id: product.id } })
    }
  },
  computed: {
    activeSection() {
      switch (this.routerName) {
        case 'home':
          return 1
        case 'catalogue':
        case 'products':
          return 2
        case 'quotations':
          return 3
        default:
          return undefined
      }
    },
    activeSectionMobile() {
      switch (this.routerName) {
        case 'my-profile':
          return 1
        case 'favorites':
          return 2
        case 'home':
          return 3
        case 'catalogue':
          return 4
        case 'quotations':
          return 5
        default:
          return undefined
      }
    },
    urlOriginIsBrandIn() {
      const currentHost = (window.location?.host || '').replace(/^www\./, '')
      const brandInDomain = (process.env.VUE_APP_BRAND_IN_DOMAIN || '').replace(
        /^www\./,
        ''
      )
      return currentHost === brandInDomain
    },
    isCpaCompany() {
      return this.$store.getters['auth/getCompany'].code == 'cpa'
    }
  },
  watch: {
    inputSearch() {
      if (this.timeoutSearch) {
        clearTimeout(this.timeoutSearch)
      }
      this.timeoutSearch = setTimeout(() => {
        this.handleSearch()
      }, 500)
    }
  }
}
</script>

<style scoped>
.activeSection {
  background: linear-gradient(100.7deg, #ce0100 0%, #faa306 100%);
  border-radius: 100px;
  padding: 12px;
  color: white;
}
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
